import { Button, Checkbox, Col, Form, Input, Modal, Row, Typography, useModalForm } from "@pankod/refine-antd";
import { ICompanyPBI, InputValidatorRegex } from "../../../interfaces/company";
import { urlPath } from "utility/url";
import { useState } from "react";
import type { CheckboxChangeEvent } from 'antd/es/checkbox';
const { Text } = Typography;


export const InviteUserToTeam: React.FC<{
    refetchUsers: any,
    refetchCompanyDetail: any,
    pbiId: string,
    company?: ICompanyPBI,
}> = ({ refetchUsers, refetchCompanyDetail, pbiId, company }) => {
    let url = urlPath();
    const [grantCompanyAdminRole, setCompanyAdminRole] = useState(false);
    const [grantAccountantRole, setCompanyAccountantRole] = useState(false);

    const { modalProps, formProps, show: showInviteUserModal, close: closeModal } = useModalForm<any>({
        resource: 'inviteUserToCompanyByInternalAdmin',
        dataProviderName: "grapghQl",
        action: "create",
        metaData: {
            inviterCompanyId: url.lastElement,
            pbiId: pbiId,
            grantCompanyAdminRole,
            grantAccountantRole,
        },
        redirect: false,
        onMutationSuccess(data, variables, context) {
            refetchCompanyDetail(true);
            refetchUsers(true);
            formProps.form?.resetFields();
            setCompanyAdminRole(false);
            setCompanyAccountantRole(false);
        }
    });
    modalProps.title = `Invite to Team`;
    modalProps.centered = true;
    modalProps.width = 600;
    modalProps.onCancel = () => {
        formProps.form?.resetFields();
        setCompanyAdminRole(false);
        setCompanyAccountantRole(false);
        closeModal();
    }

    return (
        <>
            {
                <Button onClick={() => { showInviteUserModal(); }} type="default">
                    Invite User
                </Button>
            }
            <Modal {...modalProps}>
                <Form {...formProps} onValuesChange={(changedValues, allValues) => {
                    console.log({ changedValues, allValues });
                }} name="userDetails" layout="vertical">
                    <Row gutter={16}>
                        <Col lg={12}>
                            <Form.Item className="w-100" rules={[
                                {
                                    message: 'Enter correct First Name',
                                    pattern: InputValidatorRegex.PERSON_NAME,
                                },
                            ]} label="First Name" name="firstName">
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col lg={12}>
                            <Form.Item label="Last Name" rules={[
                                {
                                    message: 'Enter correct Last Name',
                                    pattern: InputValidatorRegex.PERSON_NAME,
                                },
                            ]} className="w-100" name="lastName">
                                <Input />
                            </Form.Item>
                        </Col>

                        {/* 
                        TODO: UAR doesn't have the column. Revisit this section later
                        <Col lg={12}>
                            <Form.Item rules={[
                                {
                                    message: 'Max 10 digit Mobile number allowed',
                                    max: 10,
                                },
                                {
                                    message: 'Enter correct Mobile Number',
                                    pattern: InputValidatorRegex.INDIAN_MOBILE_NO,
                                },
                            ]} label="Mobile Number" name="mobileNo">
                                <Input onChange={(event: any) => {
                                    formProps.form?.setFieldsValue({ mobileNo: event?.target?.value.replace(/[^0-9]/g, '') })
                                }} maxLength={10} />
                            </Form.Item>
                        </Col> */}
                        <Col lg={12}>
                            <Form.Item rules={[
                                {
                                    message: 'Email ID is required',
                                    required: true,
                                },
                                {
                                    message: 'Enter correct email address',
                                    pattern: InputValidatorRegex.EMAIL_CASE_INSENSITIVE,
                                },
                            ]} label="Email ID" name="emailId">
                                <Input />
                            </Form.Item>
                        </Col>

                        {
                            <Form.Item hidden={true} label="Card Integration ID" name="cardIntegrationId" initialValue={company?.productsBundle?.cardIntegration?.id}>
                            </Form.Item>
                        }

                    </Row>
                    <Row>
                        <Col lg={12}>
                            <Row>
                                <Col><Text strong>Role</Text></Col>
                            </Row>

                            <Row>
                                <Col>
                                    <Checkbox checked={grantCompanyAdminRole} onChange={(e: CheckboxChangeEvent) => { setCompanyAdminRole(e.target.checked) }}>
                                        Company Admin
                                    </Checkbox>
                                </Col>
                                <Col>
                                    <Checkbox checked={grantAccountantRole} onChange={(e: CheckboxChangeEvent) => { setCompanyAccountantRole(e.target.checked) }}>
                                        Company Accountant
                                    </Checkbox>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Form>
            </Modal>
        </>
    );
};
